import {
  Paper,
  List,
  ListItemButton,
  ListItemIcon,
  SxProps,
  Theme,
  Tooltip
} from '@mui/material';

interface ComponentProps {
  open: boolean;
  icon: JSX.Element;
  children: JSX.Element | JSX.Element[];
  sx?: SxProps<Theme>;
  toolTipTitle?: string;
  onClick: () => void;
  onMouseLeave: () => void;
}

export default ({
  open,
  icon,
  children,
  sx,
  toolTipTitle,
  onClick,
  onMouseLeave
}: ComponentProps) => {
  const renderSubmenu = () => {
    return (
      <List
        sx={{
          position: 'fixed',
          left: '75px',
          transform: 'translate(0, -50%)',
          bgcolor: 'background.paper',
          ...sx
        }}
        component="nav"
        onMouseLeave={onMouseLeave}
      >
        <Paper elevation={1}>{children}</Paper>
      </List>
    );
  };

  return (
    <>
          <Tooltip title={toolTipTitle} placement="right" disableInteractive>
        <ListItemButton onClick={onClick}>
          <ListItemIcon style={{ minWidth: 'auto' }}>{icon}</ListItemIcon>
        </ListItemButton>
      </Tooltip>
      {open ? renderSubmenu() : null}
    </>
  );
};
